<template>
	<div class="input-code-wrapper">
		<label class="label">Введите код из смс</label>
		<div class="pincode">
			<input
				class="input"
				:class="error && 'error'"
				v-model="pin1"
				v-mask="'#'"
				ref="pin1"
				type="number"
			>
			<input
				class="input"
				:class="error && 'error'"
				v-model="pin2"
				v-mask="'#'"
				ref="pin2"
				type="number"
				@keyup.delete="!pin2 && clear('pin1')"
			>
			<input
				class="input"
				:class="error && 'error'"
				v-model="pin3"
				v-mask="'#'"
				ref="pin3"
				type="number"
				@keyup.delete="!pin3 && clear('pin2')"
			>
			<input
				class="input"
				:class="error && 'error'"
				v-model="pin4"
				v-mask="'#'"
				ref="pin4"
				type="number"
				@keyup.delete="!pin4 && clear('pin3')"
			>
		</div>
	</div>
</template>

<script>
export default {
	name: 'InputPhone',
	props: {
		error: {type: Boolean, default: false},
	},
	data() {
		return {
			pin1: '',
			pin2: '',
			pin3: '',
			pin4: '',
		}
	},
	methods: {
		clear(pin) {
			this[pin] = null
			this.changeSelect()
		},
		changeSelect() {
			if (!this.pin1) {
				this.$refs.pin1.focus()
			} else if (!this.pin2) {
				this.$refs.pin2.focus()
			} else if (!this.pin3) {
				this.$refs.pin3.focus()
			} else {
				this.$refs.pin4.focus()
			}
		}
	},
	watch: {
		pin1() {
			this.pin2 = null
			this.pin3 = null
			this.pin4 = null
			this.changeSelect()
		},
		pin2() {
			if (this.pin1) {
				this.pin3 = null
				this.pin4 = null
			} else {
				this.pin1 = this.pin2
				this.pin2 = null
			}
			this.changeSelect()
		},
		pin3() {
			if (this.pin2) {
				this.pin4 = null
			} else {
				this.pin2 = this.pin3
				this.pin3 = null
			}
			this.changeSelect()
		},
		pin4() {
			if (this.pin3) {
				this.$emit('input', `${this.pin1}${this.pin2}${this.pin3}${this.pin4}`)
			} else {
				this.pin3 = this.pin4
				this.pin4 = null
			}
		},
	},
	mounted() {
		this.$refs.pin1.focus()
	}
}
</script>

<style lang="scss" scoped>
	.input-code-wrapper {
		width: 380px;
		max-width: 100%;
		display: flex;
		justify-content: center;
		flex-direction: column;
		text-align: center;
		margin: 0 auto;

	}
	.pincode {
		display: grid;
		grid-template-columns: repeat(4, 40px);
		gap: 30px;
		margin: 0 auto;
		justify-content: center;
	}
	.label {
		font-weight: 400;
		font-size: 30px;
		line-height: 23px;
		margin-bottom: 30px;
		text-align: center;
	}
	.input {
		border:none;
		border-bottom: 1px solid #b3b3b3;
		font-size: 40px;
		border-radius: 0;
		padding: 0;
		font-family: 'Roboto';
		outline: none;
		width: 100%;
		outline: none;
		box-sizing: border-box;
		color: #00ADEE;
		background-color: transparent;
		text-align: center;


		/* Chrome, Safari, Edge, Opera */
		&::-webkit-outer-spin-button,
		&::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}

		/* Firefox */
		&[type=number] {
			-moz-appearance: textfield;
		}
	}
	.error {
		border-color: #EB6161;
	}
</style>
